import { z } from 'zod';

export const rateUsSchema = z.object({
    name: z
        .string()
        .min(2, 'Name must be at least 2 characters')
        .max(100, 'Name is too long'),
    email: z
        .string()
        .email('Invalid email address')
        .optional()
        .or(z.literal('')),
    company: z
        .string()
        .max(100, 'Company name is too long')
        .optional()
        .or(z.literal('')),
    position: z
        .string()
        .max(100, 'Position is too long')
        .optional()
        .or(z.literal('')),
    rating: z
        .number()
        .int()
        .min(1, 'Please select a rating')
        .max(5),
    commentEn: z
        .string()
        .min(10, 'Review must be at least 10 characters')
        .max(2000, 'Review is too long'),
    commentAr: z
        .string()
        .max(2000, 'Review is too long')
        .optional()
        .or(z.literal('')),
    isAnonymous: z.boolean().optional(),
});

export type RateUsFormData = z.infer<typeof rateUsSchema>;
export type RateUsFormErrors = Partial<Record<keyof RateUsFormData, string>>;

export function validateRateUs(
    data: unknown
): { success: true; data: RateUsFormData } | { success: false; errors: RateUsFormErrors } {
    const result = rateUsSchema.safeParse(data);
    if (result.success) return { success: true, data: result.data };

    const errors: RateUsFormErrors = {};
    for (const issue of result.error.issues) {
        const field = issue.path[0] as keyof RateUsFormData;
        if (field && !errors[field]) {
            errors[field] = issue.message;
        }
    }
    return { success: false, errors };
}
